import type * as ents from '@attain-apps/entities'

import type * as models from '../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  /**
   * @see {@link models.widget.RenderingLookup}
   */
  lookup: models.widget.RenderingLookup
}
export namespace State {
  export const INITIAL: State = {
    lookup: {},
  }
}
